import { createGlobalStyle } from 'styled-components'
import { styleSizes } from 'constants/styleSizes';

const GlobalStyle = createGlobalStyle`
  @media only screen and (max-width: ${styleSizes.wideScreenBreakpoint}) {
    ::-webkit-scrollbar {
      width: 0;
    }

    ::-moz-scrollbar {
      width: 0;
    }
  }

  /**Overwrite Footer map */
  #map .ol-attribution .ol-unselectable .ol-control .ol-collapsed {
    display: none;
  }

  #map .ol-rotate .ol-unselectable .ol-control .ol-hidden{
    display:none;
  }

  #map .ol-rotate-reset{
    display:none;
  }

  #map .ol-attribution {
  display: none;
  } 
`;

export default GlobalStyle;
